/**
 * NOTE: Newer version of the AddressInput component.
 * The old version is overly complex and causes issue with
 * editing the address of a product.
 * */

import React, { useState, useEffect, useMemo } from "react";
import { getaddress } from "../../../../functions";
import Select from "react-select";
import "./index.css";

export default function EditAddressInput({
  productAddress,
  onSelectNewAddress,
  hex,
  white,
}) {
  const [isLoading, setLoading] = useState(false);
  const [addressInput, setAddressInput] = useState("");
  // TODO: It might be better raising selectedAddress state for easier from resets
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [addressOptions, setAddressOptions] = useState([]);

  const Styles = useMemo(
    () => ({
      control: (styles) => ({
        ...styles,
        backgroundColor: "white",
        width: "100%",
      }),
    }),
    [selectedAddress]
  );

  useEffect(() => {
    setSelectedAddress(productAddress ? productAddress : null);
    setAddressInput(productAddress ? productAddress.label : "");
  }, []);

  /** when closing the EditPackage modal, all changes in product address are reset
   and this useEffect is triggered to also reset all inputs in this component */
  useEffect(() => {
    setSelectedAddress(productAddress ? productAddress : null);
    setAddressInput(productAddress ? productAddress.label : "");
    setAddressOptions([]);
  }, [productAddress]);

  const findAddress = async (e) => {
    e.preventDefault();
    if (!addressInput) return;

    setLoading(true);
    try {
      const res = await getaddress(addressInput);
      if (res.status === "OK") {
        const returnedAddressOptions = res.results.map((addressObj) => {
          return { label: addressObj.formatted_address, value: addressObj };
        });

        setAddressOptions(returnedAddressOptions);
      } else setAddressOptions([{ value: "No Address", label: "No Address" }]);

      setLoading(false);
    } catch (err) {
      console.log("findAddress() error", err);
      setLoading(false);
      setAddressOptions([{ value: "No Address", label: "No Address" }]);
    }
  };

  const onChangeAddress = ({ target }) => {
    selectedAddress && setSelectedAddress(null);
    setAddressInput(target.value);
  };

  const onSelectAddressOption = (addressOption) => {
    setSelectedAddress(addressOption);
    onSelectNewAddress(addressOption);
  };

  return (
    <form className="address-input" onSubmit={findAddress}>
      <div className="address-input__top-container">
        <input
          type="text"
          className="form-control"
          name="address"
          placeholder="Address"
          onChange={onChangeAddress}
          value={addressInput}
        />
        <button
          className={`btn btn-white btn-brand-hex ml-2`}
          style={{
            "--hover-color": hex ? hex : "white",
            "--hover-text-color": white ? "white" : "black",
            backgroundColor: hex ? hex : "white",
            color: white ? "white" : "black",
          }}
        >
          Find Address
        </button>
      </div>
      {isLoading && <i className="fa fa-2x fa-sync fa-spin text-muted" />}
      {addressOptions.length > 0 && (
        <div className="mt-2 select-container">
          <Select
            placeholder="Select full address..."
            value={selectedAddress}
            onChange={onSelectAddressOption}
            options={addressOptions}
            styles={Styles}
            menuPlacement="bottom"
          />
        </div>
      )}
    </form>
  );
}



// WEBPACK FOOTER //
// ./src/screens/super_products/components/EditAddressInput/index.js